import Middleware from './middleware'
import { Auth, authMiddleware, ExpiredAuthSessionError } from '~auth/runtime'

// Active schemes
import { RefreshScheme } from '~auth/runtime'

Middleware.auth = authMiddleware

export default function (ctx, inject) {
  // Options
  const options = {
  "resetOnError": false,
  "ignoreExceptions": false,
  "scopeKey": "scope",
  "rewriteRedirects": true,
  "fullPathRedirect": false,
  "watchLoggedIn": true,
  "redirect": {
    "login": "/sign-in",
    "logout": "/",
    "home": false,
    "callback": "/sign-in"
  },
  "vuex": {
    "namespace": "auth"
  },
  "cookie": {
    "prefix": "auth.",
    "options": {
      "path": "/"
    }
  },
  "localStorage": {
    "prefix": "auth."
  },
  "defaultStrategy": "local"
}

  // Create a new Auth instance
  const $auth = new Auth(ctx, options)

  // Register strategies
  // local
  $auth.registerStrategy('local', new RefreshScheme($auth, {
  "token": {
    "property": "token",
    "global": false,
    "maxAge": 86400
  },
  "refreshToken": {
    "property": "refresh_token",
    "data": "refresh_token",
    "maxAge": 7776000
  },
  "user": {
    "property": false
  },
  "endpoints": {
    "login": {
      "url": "https://api.oblyk.org/api/v1/sessions/sign_in",
      "headers": {
        "HttpApiAccessToken": "M4rvBxc4M7kqqdtXPDvFEYm9"
      },
      "method": "post"
    },
    "refresh": {
      "url": "https://api.oblyk.org/api/v1/sessions/tokens",
      "headers": {
        "HttpApiAccessToken": "M4rvBxc4M7kqqdtXPDvFEYm9"
      },
      "method": "post"
    },
    "logout": {
      "url": "https://api.oblyk.org/api/v1/sessions/sign_in",
      "headers": {
        "HttpApiAccessToken": "M4rvBxc4M7kqqdtXPDvFEYm9"
      },
      "method": "delete"
    },
    "user": {
      "url": "https://api.oblyk.org/api/v1/current_users",
      "headers": {
        "HttpApiAccessToken": "M4rvBxc4M7kqqdtXPDvFEYm9"
      },
      "method": "get"
    }
  },
  "name": "local"
}))

  // Inject it to nuxt context as $auth
  inject('auth', $auth)
  ctx.$auth = $auth

  // Initialize auth
  return $auth.init().catch(error => {
    if (process.client) {
      // Don't console log expired auth session errors. This error is common, and expected to happen.
      // The error happens whenever the user does an ssr request (reload/initial navigation) with an expired refresh
      // token. We don't want to log this as an error.
      if (error instanceof ExpiredAuthSessionError) {
        return
      }

      console.error('[ERROR] [AUTH]', error)
    }
  })
}
